const routerAdmin = [
    {
        path: '/',
        redirect: {
            name: 'adminInstance'
        }
    },
    /* -------------------------------- DASHBOARD ------------------------------- */
    {
        path: 'dashboard',
        name: 'adminDashboard',
        component: () => import('../views/admin/dashboard/index.vue'),
        meta: {
            pagePermission: 'dashboard.index'
        }
    },
    {
        path: 'log',
        name: 'adminLog',
        component: () => import('../views/admin/log/index.vue'),
        meta: {
            pagePermission: 'log.index'
        }
    },
    {
        path: 'setting',
        name: 'adminSetting',
        component: () => import('../views/admin/setting/index.vue'),
        meta: {
            pagePermission: 'setting.index'
        }
    },
    /* -------------------------------- END DASHBOARD ------------------------------- */

    /* -------------------------------- INSTANCE ------------------------------- */
    {
        path: 'instance',
        name: 'adminInstance',
        component: () => import('../views/admin/instance/index.vue'),
        meta: {
            pagePermission: 'instance.index'
        }
    },
    {
        path: 'instance/create',
        name: 'adminInstanceCreate',
        component: () => import('../views/admin/instance/form.vue'),
        meta: {
            pagePermission: 'instance.create'
        }
    },
    {
        path: 'instance/:id/edit/',
        name: 'adminInstanceEdit',
        component: () => import('../views/admin/instance/form.vue'),
        meta: {
            pagePermission: 'instance.edit'
        }
    },
    /* -------------------------------- END INSTANCE ------------------------------- */

    /* -------------------------------- GROUP ------------------------------- */
    {
        path: 'group',
        name: 'adminGroup',
        component: () => import('../views/admin/group/index.vue'),
        meta: {
            pagePermission: 'group.index'
        }
    },
    {
        path: 'group/create',
        name: 'adminGroupCreate',
        component: () => import('../views/admin/group/form.vue'),
        meta: {
            pagePermission: 'group.create'
        }
    },
    {
        path: 'group/:id/edit/',
        name: 'adminGroupEdit',
        component: () => import('../views/admin/group/form.vue'),
        meta: {
            pagePermission: 'group.edit'
        }
    },
    /* -------------------------------- END GROUP ------------------------------- */

    /* -------------------------------- ORGANIZATION ------------------------------- */
    {
        path: 'organization',
        name: 'adminOrganization',
        component: () => import('../views/admin/organization/index.vue'),
        meta: {
            pagePermission: 'organization.index'
        }
    },
    {
        path: 'organization/create',
        name: 'adminOrganizationCreate',
        component: () => import('../views/admin/organization/form.vue'),
        meta: {
            pagePermission: 'organization.create'
        }
    },
    {
        path: 'organization/:id/edit/',
        name: 'adminOrganizationEdit',
        component: () => import('../views/admin/organization/form.vue'),
        meta: {
            pagePermission: 'organization.edit'
        }
    },
    /* -------------------------------- END ORGANIZATION ------------------------------- */

    /* -------------------------------- GROUP ------------------------------- */
    {
        path: 'group/:id',
        name: 'adminGroupUser',
        component: () => import('../views/admin/group/user/index.vue'),
        meta: {
            pagePermission: 'group.user.index'
        }
    },
    {
        path: 'group/:id/create',
        name: 'adminGroupUserCreate',
        component: () => import('../views/admin/group/user/form.vue'),
        meta: {
            pagePermission: 'group.user.create'
        }
    },
    {
        path: 'group/:id/edit/:userid',
        name: 'adminGroupUserEdit',
        component: () => import('../views/admin/group/user/form.vue'),
        meta: {
            pagePermission: 'group.user.edit'
        }
    },
    /* -------------------------------- END GROUP ------------------------------- */

    /* -------------------------------- FORM ENGINE ------------------------------- */
    {
        path: 'instance/:id/form-engine',
        name: 'adminFormEngine',
        component: () => import('../views/admin/formEngine/index.vue')
    },
    {
        path: 'instance/:id/form-engine/create',
        name: 'adminFormEngineCreate',
        component: () => import('../views/admin/formEngine/form.vue')
    },
    {
        path: 'instance/:id/form-engine/:id_form/edit',
        name: 'adminFormEngineEdit',
        component: () => import('../views/admin/formEngine/form.vue')
    },
    /* -------------------------------- END FORM ENGINE ------------------------------- */

    /* -------------------------------- SERVICE ------------------------------- */
    {
        path: 'instance/:id/object-retribution',
        name: 'adminServices',
        component: () => import('../views/admin/services/index.vue')
    },
    {
        path: 'instance/:id/object-retribution/create',
        name: 'adminServicesCreate',
        component: () => import('../views/admin/services/form.vue')
    },
    {
        path: 'instance/:id/object-retribution/:id_service/edit',
        name: 'adminServicesEdit',
        component: () => import('../views/admin/services/form.vue')
    },
    /* -------------------------------- END SERVICE ------------------------------- */

    /* -------------------------------- MASTER DATA ------------------------------- */
    {
        path: 'instance/:id/master-data',
        name: 'adminMasterData',
        component: () => import('../views/admin/masterData/index.vue'),
        meta: {
            pagePermission: 'master-data.index'
        }
    },
    {
        path: 'instance/:id/master-data/create',
        name: 'adminMasterDataCreate',
        component: () => import('../views/admin/masterData/form.vue'),
        meta: {
            pagePermission: 'master-data.store'
        }
    },
    {
        path: 'instance/:id/master-data/:id_master_data/edit',
        name: 'adminMasterDataEdit',
        component: () => import('../views/admin/masterData/form.vue'),
        meta: {
            pagePermission: 'master-data.update'
        }
    },
    /* -------------------------------- END MASTER DATA ------------------------------- */

    /* -------------------------------- USER ------------------------------- */
    {
        path: 'user',
        name: 'adminUser',
        component: () => import('../views/admin/user/index.vue'),
        meta: {
            pagePermission: 'user.index'
        }
    },
    {
        path: 'user/create',
        name: 'adminUserCreate',
        component: () => import('../views/admin/user/form.vue'),
        meta: {
            pagePermission: 'user.create'
        }
    },
    {
        path: 'user/:id/edit/',
        name: 'adminUserEdit',
        component: () => import('../views/admin/user/form.vue'),
        meta: {
            pagePermission: 'user.edit'
        }
    },
    /* -------------------------------- END USER ------------------------------- */
]

export default routerAdmin